import { render, staticRenderFns } from "./Hs.vue?vue&type=template&id=0638e924&scoped=true"
import script from "./Hs.vue?vue&type=script&lang=js"
export * from "./Hs.vue?vue&type=script&lang=js"
import style0 from "./Hs.vue?vue&type=style&index=0&id=0638e924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638e924",
  null
  
)

export default component.exports